<template>
  <div id="app" class="system-builder__root" :style="{paddingBottom: navHeight}">
    <transition name="fade" mode="out-in" appear v-if="sharedState.showMainNav">
      <headerNav></headerNav>
    </transition>
    <transition name="slider-fade" mode="out-in" appear>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  import 'babel-polyfill'
  import store from './store'
  import $ from 'jquery'
  import headerNav from './components/reusable/header.vue'

  export default {
    components: {headerNav},
    name: 'app',
    data () {
      return {
        sharedState: store.state
      }
    },
    methods: {
      retrieveProducts: function () {
        var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php'

        store.toggleVehicleContinueButton(false)

        $.ajax({
          url: ajaxUrl,
          type: 'POST',
          dataType: 'text',
          timeout: 7000,
          data: {
            action: 'system-builder-get-remotes'
          },
          cache: false,
          success: function (response) {
            var jsonObj = JSON.parse(response)
            store.holdRemotes(jsonObj.remotes)
            store.holdCustomFields(jsonObj.custom_fields)
            store.toggleVehicleContinueButton(true)
            return false
          }
        })
      }
    },
    mounted: function () {
      store.getLocalStorage()
      if (this.sharedState.remotes === null) {
        this.retrieveProducts()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?35c70771